export default __webpack_public_path__ + "static/CoreDaoOpti-4d975bcf8fa1b5b8615d8b9c2f16fab7.gif";